export default __webpack_public_path__ + "static/media/shopCategory-4.fdc49736.png";